import { useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../../hooks/useSpace';
import { keys as documentKeys } from '../../api/keys';
import { useDeleteDocuments } from '../../api/useDeleteDocuments';
import useDeleteFilesFromGoogleDrive from '../../api/useDeleteFilesFromGoogleDrive';
import { keys as topicKeys } from '../../../topics/api/keys';

export type DocumentToDelete = {
  id: string;
  name: string;
  fileUrl: string;
};

type Props = {
  document: DocumentToDelete;
};

export default function useDeleteDocumentModal(props: Props) {
  const { currentSpace } = useSpace();
  const queryClient = useQueryClient();
  const { mutateAsync: deleteDocuments } = useDeleteDocuments();
  const { mutateAsync: deleteFilesFromDrive } = useDeleteFilesFromGoogleDrive();

  async function handleConfirm() {
    if (currentSpace && props.document.fileUrl) {
      try {
        await deleteFilesFromDrive({
          fileUrls: [props.document.fileUrl],
          spaceId: currentSpace.id,
        });
      } catch (err) {
        console.warn('Could not delete file from Google Drive:', err);
      }
    }

    await deleteDocuments({ ids: [props.document.id] });

    queryClient.invalidateQueries({ queryKey: documentKeys.documents });
    queryClient.invalidateQueries({ queryKey: [...topicKeys.all, 'activityTimeline'] });
    queryClient.invalidateQueries({ queryKey: topicKeys.all });

    enqueueSnackbar('Document supprimé.', 'success');
  }

  return {
    handleConfirm,
  };
}
